<!--
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-10-18 18:29:30
 * @Version: 1.0
 * @Description: 编辑、发布运力页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div v-loading="viewManager.loading" class="publish-transport-container">
    <div class="publish-transport-header">
      <template v-if="viewManager.isEdit">
        <div class="publish-transport-header-title active">编辑运力</div>
      </template>
      <template v-else>
        <section style="display:inline-block" @click="toggleState">
          <div class="publish-transport-header-title" :class="{'active': !Boolean(viewManager.state)}" data-state="0">保存运力</div>
          <div class="publish-transport-header-title" :class="{'active': Boolean(viewManager.state)}" data-state="1">
            发布运力</div>
        </section>
      </template>
    </div>
    <div class="publish-transport-body">
      <el-form v-if="Boolean(viewManager.state)" ref="transportForm" :model="data.formModal" :rules="config.requiredRules"
        label-position="right" label-width="6rem">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运地" prop="startPlace" required>
              <el-cascader ref="startPlace" v-model="data.formModal.startPlace" :options="data.area" :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }" @expand-change="expandChange" @change="cascaderclose" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="startPlaceDetail">
              <el-autocomplete v-model="data.formModal.startPlaceDetail" :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址" style="width: 100%;">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="目的地" prop="stopPlace" required>
              <el-cascader ref="stopPlace" v-model="data.formModal.stopPlace" :filterable="true" :options="data.area"
                :props="{ expandTrigger: 'hover', checkStrictly: true }" @expand-change="expandChange" @change="cascadercloseStop" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="stopPlaceDetail">
              <el-autocomplete v-model="data.formModal.stopPlaceDetail" :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址" style="width: 100%;">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="运输方式" prop="transportType" required>
              <el-select v-model="data.formModal.transportType" multiple>
                <el-option v-for="item of data.transportType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输品类" prop="goodsType" required>
              <el-select v-model="data.formModal.goodsType">
                <el-option v-for="item of data.goodsType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="承载能力" prop="weight" required>
              <el-input v-model="data.formModal.weight" placeholder="请输入">
                <span slot="suffix">吨</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望运价" prop="expectPrice">
              <el-input v-model="data.formModal.expectPrice" placeholder="请输入">
                <span slot="suffix">元/吨公里</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运时间" prop="earliestTime" required>
              <!--:picker-options="data.startPickerOptions"-->
              <el-date-picker v-model="data.formModal.earliestTime" type="datetime" :editable="false" :clearable="false"
                placeholder="选择日期时间" :picker-options="data.startPickerOptions" @change="changeTime" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到达时间" prop="latestTime" required>
              <el-date-picker v-model="data.formModal.latestTime" :editable="false" :clearable="false" type="datetime"
                placeholder="选择日期时间" :picker-options="data.endPickerOptions" @change="changeTimeOut" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系人" prop="shipmentName" required>
              <el-input v-model="data.formModal.shipmentName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系电话" prop="shipmentTel" required>
              <el-input v-model="data.formModal.shipmentTel" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="运力图片" class="upload-container" prop="fileUrl">
            请上传不大于5M，jpg,png类型图片
            <g-upload v-if="!viewManager.loading" :multiple="updataMultiple" :max-size="5" method-name="transportFile"
              :img-list.sync="data.formModal.fileUrl" @update:imgList="deleteImgCallBack" />
          </el-form-item>
        </el-row>

        <el-form-item label="备注信息" prop="remarks">
          <el-input v-model="data.formModal.remarks" type="textarea" placeholder="请输入" />
        </el-form-item>
      </el-form>

      <el-form v-else-if="viewManager.isEdit || !Boolean(viewManager.state)" ref="transportForm" :model="data.formModal"
        :rules="config.rules" label-position="right" label-width="6rem">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运地" prop="startPlace">
              <el-cascader ref="startPlace" v-model="data.formModal.startPlace" :filterable="true" :options="data.area"
                :props="{ expandTrigger: 'hover', checkStrictly: true }" @expand-change="expandChange" @change="cascaderclose" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="startPlaceDetail">
              <el-autocomplete v-model="data.formModal.startPlaceDetail" :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址" style="width: 100%;">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader ref="stopPlace" v-model="data.formModal.stopPlace" :filterable="true" :options="data.area"
                :props="{ expandTrigger: 'hover', checkStrictly: true }" @expand-change="expandChange" @change="cascadercloseStop"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址" prop="stopPlaceDetail">
              <el-autocomplete v-model="data.formModal.stopPlaceDetail" :fetch-suggestions="querySearchAsync"
                placeholder="请输入详细地址" style="width: 100%;">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="运输方式" prop="transportType">
              <el-select v-model="data.formModal.transportType" multiple>
                <el-option v-for="item of data.transportType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输品类" prop="goodsType">
              <el-select v-model="data.formModal.goodsType">
                <el-option v-for="item of data.goodsType" :key="item.id" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="承载能力" prop="weight">
              <el-input v-model="data.formModal.weight" placeholder="请输入">
                <span slot="suffix">吨</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望运价" prop="expectPrice">
              <el-input v-model="data.formModal.expectPrice" placeholder="请输入">
                <span slot="suffix">元/吨公里</span>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="起运时间" prop="earliestTime">
              <!--:picker-options="data.startPickerOptions"-->
              <el-date-picker v-model="data.formModal.earliestTime" type="datetime" :editable="false" placeholder="选择日期时间"
                :clearable="false" @change="changeTime" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到达时间" prop="latestTime">
              <el-date-picker v-model="data.formModal.latestTime" type="datetime" :editable="false" :clearable="false"
                placeholder="选择日期时间" :picker-options="data.endPickerOptions" @change="changeTimeOut" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系人" prop="shipmentName">
              <el-input v-model="data.formModal.shipmentName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-inputFilter label="联系电话" prop="shipmentTel">
              <el-input v-model="data.formModal.shipmentTel" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="运力图片" class="upload-container" prop="fileUrl">
            请上传不大于5M，jpg,png类型图片
            <g-upload v-if="!viewManager.loading" :multiple="updataMultiple" method-name="transportFile" :img-list.sync="data.formModal.fileUrl"
              :max-size="5" @update:imgList="deleteImgCallBack" />
          </el-form-item>
        </el-row>

        <el-form-item label="备注信息" prop="remarks">
          <el-input v-model="data.formModal.remarks" type="textarea" placeholder="请输入" />
        </el-form-item>
      </el-form>
    </div>
    <div class="publish-transport-footer">
      <el-button v-if="!viewManager.isEdit && !Boolean(viewManager.state)" type="danger" plain size="small" @click="save()">保存</el-button>
      <el-button v-if="!viewManager.isEdit && Boolean(viewManager.state)" type="danger" size="small" @click="save()">发布</el-button>
      <el-button v-if="viewManager.isEdit" type="danger" size="small" @click="edit()">提交</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
  </div>
</template>
<script>
  import {
    save,
    getDetails
  } from '@/api/personal/find/transportManager'

  import {
    rules,
    requiredRules
  } from '../dataConfig/rules'

  import mixinsFunction from '@/utils/mixinsFunction'

  import dictionary from '../dataConfig/dictionary.json'

  import {
    mapGetters
  } from 'vuex'

  import AMap from 'AMap'

  const State = {
    Save: 0,
    Publish: 1
  }

  export default {
    name: 'PublishTransport',
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.detificateSuccess().then(() => {})
      })
    },
    beforeRouteUpdate(to, from, next) {
      this.detificateSuccess().then(() => {
        next()
      })
    },
    mixins: [mixinsFunction],
    data: function() {
      return {
        updataMultiple: false,
        //地址选中的个数
        XCount: 0,
        data: {
          // 结束日期
          endPickerOptions: {
            disabledDate: (time) => {
              const beginDateVal = this.data.formModal.earliestTime
              if (beginDateVal) {
                return time.getTime() <= beginDateVal.getTime() - 1000 * 60 * 60 * 24
              } else {
                return time.getTime() < new Date().getTime()
              }
            }
          },

          //  开始日期
          startPickerOptions: {
            disabledDate: (time) => {
              let state = time.getTime() < new Date().getTime() - 1000 * 60 * 60 * 24
              if (state) {
                return state
              }
              const endDateVal = this.data.formModal.latestTime
              if (endDateVal) {
                state = time.getTime() >= endDateVal.getTime()
              }
              return state
            }
          },
          dictionary: dictionary,
          // 地址
          area: [],
          // 货物类型
          goodsType: [],
          // 运输方式
          transportType: [],
          formModal: {
            startPlace: [],
            startPlaceDetail: '',
            stopPlace: [],
            stopPlaceDetail: '',
            transportType: [],
            goodsType: '',
            weight: '',
            expectPrice: '',
            earliestTime: '',
            latestTime: '',
            shipmentName: '',
            shipmentTel: '',
            fileUrl: '',
            remarks: '',
            sendStatus: 0
          }
        },
        config: {
          requiredRules: requiredRules,
          rules: rules
        },
        viewManager: {
          visible: false, // 是否显示
          loading: true, // 是否加载
          isEdit: false, //  是否是编辑状态
          state: State.Save,
          close: () => { // 关闭
            this.viewManager.visible = false
            this.$emit('close', false)
          }
        }
      }
    },
    computed: {
      ...mapGetters(['userInfo'])
    },
    watch: {
      '$route': {
        handler: function() {
          // 刷新数据
          this.cleanModal(this.data.formModal)
        }
      }
    },
    created: function() {
      this.init()
    },
    methods: {
      // 选择开始时间，清空结束时间
      changeTime(date) {
        const earliestTime = this.data.formModal.earliestTime == '' ? 0 : this.data.formModal.earliestTime.getTime()
        const latestTime = this.data.formModal.latestTime == '' ? 0 : this.data.formModal.latestTime.getTime()
        if (earliestTime > latestTime) {
          this.data.formModal.latestTime = ''
        }
      },
      // 选择结束日期，清空开始时间
      changeTimeOut(date) {
        // 开始日期
        const earliestTime = this.data.formModal.earliestTime == '' ? 0 : this.data.formModal.earliestTime.getTime()
        // 结束日期
        const latestTime = this.data.formModal.latestTime == '' ? 0 : this.data.formModal.latestTime.getTime()
        console.log(earliestTime, latestTime)
        if (earliestTime > latestTime) {
          this.data.formModal.earliestTime = ''
        }
      },
      // 删除图片成功后的回调
      deleteImgCallBack(imgs) {
        this.data.formModal.fileUrl = imgs
      },
      initData() {
        this.data.formModal.shipmentName = this.userInfo.realName
        this.data.formModal.shipmentTel = this.userInfo.phone
      },
      toggleState(e) {
        const t = e.target
        if (t && t.dataset) {
          this.viewManager.state = parseInt(t.dataset.state)
        } else {
          this.viewManager.state = parseInt(t.getAttribute('data-value'))
        }
        this.reset()
        this.initData()
        this.$nextTick(() => {
          this.$refs['transportForm'].clearValidate()
        })
      },
      expandChange() {
        setTimeout(function() {
          var alist = document.getElementsByClassName('el-radio__original')
          if (alist) {
            for (var idx = 0; idx < alist.length; idx++) {
              var mya = alist[idx]
              mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
            }
          }
        }, 300)
      },
      querySearchAsync(query, cb) {
        let address
        if (query === this.data.formModal.startPlaceDetail) {
          if (this.data.formModal.startPlace && this.data.formModal.startPlace.length > 0) {
            address = this.data.formModal.startPlace
          } else {
            this.$message({
              message: '请先选择起始地!',
              offset: 100,
              type: 'warning'
            })
            this.$refs['startPlace'].$children[0].$el.children[0].focus()
            cb([])
          }
        } else if (query === this.data.formModal.stopPlaceDetail) {
          if (this.data.formModal.stopPlace && this.data.formModal.stopPlace.length > 0) {
            address = this.data.formModal.stopPlace
          } else {
            this.$message({
              message: '请先选择目的地!',
              offset: 100,
              type: 'warning'
            })
            this.$refs['stopPlace'].$children[0].$el.children[0].focus()
            cb([])
          }
        }
        const results = []
        if (!query) {
          cb(results)
          return false
        }
        AMap.service(['AMap.PlaceSearch'], () => {
          // 构造地点查询类
          const placeSearch = new AMap.PlaceSearch({
            pageSize: 5, // 单页显示结果条数
            pageIndex: 1, // 页码
            city: address[address.length - 1],
            citylimit: true // 是否强制限制在设置的城市内搜索
          })
          // 关键字查询
          placeSearch.search(query, (status, result) => {
            if (status == 'complete') {
              result.poiList.pois.forEach(element => {
                results.push({
                  'title': element.name,
                  'value': element.address + element.name,
                  'address': element.name,
                  'location': element.location
                })
              })
              cb(results)
            }
          })
        })
      },
      async init() {
        // 通过路由获取要编辑运力的id
        const id = this.$route.query.transportId
        if (id && id !== '') {
          // 如果运力ID不为空时，就是编辑运力， 把编辑状态设置为true
          this.viewManager.isEdit = true
          await Promise.all([this.getArea(), this.getGoodsType(), this.getTransportType(), this.getTransport(id)])
            .then(data => {
              [this.data.area, this.data.goodsType, this.data.transportType] = data
            })
        } else {
          await Promise.all([this.getArea(), this.getGoodsType(), this.getTransportType()])
            .then(data => {
              [this.data.area, this.data.goodsType, this.data.transportType] = data
            })
          this.initData()
        }
        this.viewManager.loading = false
      },
      //  获取运力详情
      getTransport(id) {
        this.viewManager.loading = true
        return getDetails(id)
          .then(data => {
            this.data.formModal = this.parseData(data.result)
            if (this.data.formModal.earliestTime) {
              this.data.formModal.earliestTime = new Date(Date.parse(this.data.formModal.earliestTime.replace(/-/g,
                '/')))
            }
            if (this.data.formModal.latestTime) {
              this.data.formModal.latestTime = new Date(Date.parse(this.data.formModal.latestTime.replace(/-/g, '/')))
            }
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => {
            this.viewManager.loading = false
          })
      },
      // 编辑数据
      edit() {
        this.$refs['transportForm'].validate(valid => {
          if (valid) {
            this.viewManager.loading = true
            save(this.exchangeData(this.data.formModal))
              .then(data => {
                this.$notify({
                  title: '成功',
                  message: '运力编辑成功',
                  type: 'success'
                })
                this.$router.push('./transport-list')
              })
              .catch(e => {
                this.$notify({
                  title: '失败',
                  message: '运力编辑失败',
                  type: 'error'
                })
              })
              .finally(() => {
                this.viewManager.loading = false
              })
          } else {
            this.$el.scrollIntoView()
            return false
          }
        })
      },
      // 解析参数
      parseData(data) {
        data.capacity = parseInt(data.capacity)
        if (data.startPlace) {
          data.startPlace = String(data.startPlace)
            .substring(0, data.startPlace.length - 1)
            .split('#')
        }
        if (data.stopPlace) {
          data.stopPlace = String(data.stopPlace)
            .substring(0, data.stopPlace.length - 1)
            .split('#')
        }
        if (data.transportType) {
          data.transportType = String(data.transportType).split(',')
        }
        return data
      },
      // 保存运力信息
      save() {
        this.data.formModal.sendStatus = this.viewManager.state
        this.$refs['transportForm'].validate(valid => {
          if (valid) {
            this.viewManager.loading = true
            const data = this.exchangeData(this.data.formModal)
            const state = this.viewManager.state ? '发布' : '保存'
            save(data)
              .then(data => {
                this.$notify({
                  title: state,
                  message: `运力${state}成功`,
                  type: 'success'
                })
                this.$router.push('./transport-list')
              })
              .catch(error => {
                this.$notify({
                  title: state,
                  message: `运力${state}失败`,
                  type: 'error'
                })
                console.error(error)
              })
              .finally(complete => {
                this.viewManager.loading = false
              })
          } else {
            this.$el.scrollIntoView()
            return false
          }
        })
      },
      // 重置表单
      reset() {
        this.cleanModal(this.data.formModal)
        // this.$refs['transportForm'].resetFields()
      },
      fileOver() {
        this.$message({
          message: '上传图片不能超过3张',
          type: 'warning'
        })
      },
      cascaderclose(val) {
        this.XCount++;
        if (this.XCount >= 3) {
          this.$refs.startPlace.dropDownVisible = false;
          this.XCount = 0;
        }
      },
      cascadercloseStop(val) {
        this.XCount++;
        if (this.XCount >= 3) {
          this.$refs.stopPlace.dropDownVisible = false;
          this.XCount = 0;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  $prefix: "publish-transport";

  .#{$prefix}-container {
    padding: 14px 14px;
    border: 1px solid #dbdbdb;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    box-sizing: border-box;

    .#{$prefix}-header {
      height: 47px;
      border-bottom: 1px solid #dbdbdb;

      .#{$prefix}-header-title {
        height: calc(100%);
        display: inline-block;
        line-height: 48px;
        // margin: 4px 12px;
        min-width: 120px;
        font-weight: bold;
        font-size: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        cursor: pointer;

        &.active {
          color: #be2316;
          border-bottom: 1px solid #be2316 !important;
        }
      }
    }

    .#{$prefix}-body {
      padding-top: 16px;
    }

    .#{$prefix}-footer {
      // padding-top: 16px;
      text-align: center;

      button {
        border-radius: 0px !important;
      }
    }
  }

  .el-select,
  .el-cascader {
    width: 100% !important;
  }

  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    border-radius: 0px !important;
  }

  /deep/ .el-date-editor.el-input {
    width: 100% !important;
  }

  .intenal-box {
    width: 100%;
    height: 100%;
    padding: 50px 0px;

    .upload-info-text {
      margin: auto auto;
      width: 100%;
      line-height: 24px;
    }

    .upload-icon {
      margin: auto auto;
      width: 100%;
      line-height: 24px;
    }
  }

  .el-form-item__error {
    z-index: 1;
  }
</style>
